import React, { useState } from 'react';
import Cropper from 'react-cropper';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cropperjs/dist/cropper.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import Compressor from 'compressorjs';
import { IFile } from '.';
import { ButtonNext, ModalFooter } from './styled';
import { useToast } from '../../../../../../hooks/toast';

interface ContainerCropProps {
  file: IFile;
  changeToNewFileCroped: (file: any, isFirst?: boolean) => void;
  isFirst: boolean;
}

const ContainerCrop: React.FC<ContainerCropProps> = ({
  file,
  changeToNewFileCroped,
  isFirst,
}) => {
  const [cropData, setCropData] = useState('');
  const [cropper, setCropper] = useState<any>();
  const [fileCroped, setFileCroped] = useState<IFile>();

  const { addToast } = useToast();

  const dataURLtoFile = (dataurl: string): File => {
    const arr = dataurl.split(',');

    const mime = arr[0].match(/:(.*?);/)?.[1];

    const bstr = atob(arr[1]);

    let n = bstr.length;

    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], file.name, { type: mime });
  };

  const handleCompressedUpload = (_file: File): void => {
    // eslint-disable-next-line no-new
    new Compressor(_file, {
      quality: 0.6,

      success(result) {
        setFileCroped({ ...file, file: result });
      },
      error(err) {
        setFileCroped({ ...file, file: _file });
        console.log(err.message);
      },
    });
  };

  const getCropData = (): void => {
    if (typeof cropper !== 'undefined') {
      setCropData(cropper.getCroppedCanvas().toDataURL('image/jpeg'));
    }
    const newImage = dataURLtoFile(
      cropper.getCroppedCanvas().toDataURL('image/jpeg'),
    );

    handleCompressedUpload(newImage);
  };

  return (
    <div
      style={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        maxHeight: '100%',
        width: '100%',
      }}
    >
      <div style={{ display: 'flex', flexGrow: 1, maxHeight: '50%' }}>
        <Cropper
          style={{ height: '100%', width: '100%' }}
          initialAspectRatio={19 / 9}
          aspectRatio={19 / 9}
          preview=".img-preview"
          src={file.preview}
          viewMode={1}
          minCropBoxHeight={10}
          minCropBoxWidth={10}
          background={false}
          responsive
          autoCropArea={1}
          checkOrientation={false}
          onInitialized={(instance) => {
            setCropper(instance);
          }}
          guides
        />
      </div>
      <div
        style={{
          display: 'flex',
          flexGrow: 1,
          flexDirection: 'column',
          alignItems: 'center',
          maxHeight: '36%',
        }}
      >
        <button
          type="button"
          style={{
            width: '120px',
            height: '30px',
            border: '1px solid transparent',
            borderRadius: '5px',
            backgroundColor: '#3f51b5',
            color: '#fff',
          }}
          onClick={getCropData}
        >
          Realizar corte
        </button>
        <div
          style={{
            flexGrow: 1,
            padding: '10px',
            height: '85%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {!!cropData && (
            <img
              style={{ maxWidth: '100%', maxHeight: '100%' }}
              src={cropData}
              alt="cropped"
            />
          )}
        </div>
      </div>
      <ModalFooter>
        {!isFirst ? (
          <ButtonNext
            onClick={() => {
              if (cropData && fileCroped) {
                changeToNewFileCroped(fileCroped);
              } else {
                addToast({
                  type: 'info',
                  title: 'Realize o corte antes de prosseguir.',
                });
              }
            }}
          >
            Seguir
          </ButtonNext>
        ) : (
          <ButtonNext
            onClick={() => {
              if (cropData && fileCroped) {
                changeToNewFileCroped(fileCroped, true);
              } else {
                addToast({
                  type: 'info',
                  title: 'Realize o corte antes de prosseguir.',
                });
              }
            }}
          >
            Finalizar
          </ButtonNext>
        )}
      </ModalFooter>
    </div>
  );
};

export default ContainerCrop;
